import { useEffect, useState } from "react";
import { Bell, BellOff } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const urlB64ToUint8Array = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return new Uint8Array([...raw].map((c) => c.charCodeAt(0)));
};

export const PushOptIn = () => {
  const [state, setState] = useState("idle");

  useEffect(() => {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) return setState("unsupported");
    if (typeof Notification !== "undefined" && Notification.permission === "denied") setState("denied");
  }, []);

  const optIn = async () => {
    try {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") return setState("denied");
      const reg = await navigator.serviceWorker.ready;
      const key = (await axios.get(`${API}/push/public-key`)).data.publicKey;
      let sub = await reg.pushManager.getSubscription();
      if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlB64ToUint8Array(key) });
      const j = sub.toJSON();
      await axios.post(`${API}/push/inscrever`, { endpoint: sub.endpoint, keys_p256dh: j.keys.p256dh, keys_auth: j.keys.auth });
      setState("done");
      toast.success("Você vai receber as novidades da SOLLUS!");
    } catch {
      toast.error("Não foi possível ativar as notificações neste navegador.");
    }
  };

  if (state === "unsupported") return null;
  if (state === "denied")
    return (
      <span data-testid="push-optin-denied" className="inline-flex items-center gap-1.5 text-xs opacity-80">
        <BellOff className="h-3.5 w-3.5" /> Notificações bloqueadas
      </span>
    );
  if (state === "done")
    return (
      <span data-testid="push-optin-done" className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand">
        <Bell className="h-3.5 w-3.5" /> Novidades ativadas
      </span>
    );
  return (
    <button onClick={optIn} data-testid="push-optin-button"
      className="inline-flex items-center gap-1.5 rounded border border-line bg-white px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-ink transition-colors hover:border-brand hover:text-brand">
      <Bell className="h-3.5 w-3.5" /> Receber novidades
    </button>
  );
};
